module.exports = __webpack_public_path__ + "static/img/cca-6.cae9dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/cca-6.png
// module id = 964
// module chunks = 0